import { normalizeLocalizedValues } from '../util';
import { useActiveLanguage } from '../util/useActiveLanguage';
import { useCurrentUser } from './useCurrentUser';
import { useFindHotel } from './useFindHotel';

type BookitoSettingsParams = {
  hotelId?: string;
};

type BookitoSettings = {
  daysViewableInAdvance?: number | null;
  daysBookableInAdvance?: number | null;
  bannerImg?: NonNullable<
    NonNullable<ReturnType<typeof useFindHotel>['hotel']>['bookitoSettings']
  >['bannerImg'];
  appButtonTitle?: string | null;
};

export function useBookitoSettings({ hotelId: hotelIdParam }: BookitoSettingsParams = {}) {
  const { activeLanguage } = useActiveLanguage();
  const { hotelId, loading: loading1 } = useCurrentUser();
  const { hotel, loading: loading2 } = useFindHotel({ id: hotelIdParam ?? hotelId });

  const loading = loading1 || loading2;

  const localizedBookitoSettings = normalizeLocalizedValues(hotel?.bookitoSettings)?.[
    activeLanguage
  ];

  const bookitoSettings: BookitoSettings = {
    daysBookableInAdvance: hotel?.bookitoSettings?.daysBookableInAdvance ?? 14,
    daysViewableInAdvance: hotel?.bookitoSettings?.daysViewableInAdvance ?? 30,
    appButtonTitle: localizedBookitoSettings?.appButtonTitle,
    bannerImg: localizedBookitoSettings?.bannerImg,
  };

  return {
    loading,
    bookitoSettings,
  };
}
